import useMeQuery from './useMeQuery';

/**
 * Hook to find out if the user is authorized to moderate content for a session
 */
const useAuthorization = () => {
  const { data, loading, error } = useMeQuery();
  const canModerate = sessionId =>
    !!(
      data?.me?.permissions.isGlobalModerator ||
      data?.me?.permissions.sessionsToModerate.includes(sessionId)
    );

  const canModerateSession = sessionId =>
    data?.me?.permissions.isGlobalModerator ||
    data?.me?.permissions.roles.audienceEngagement.includes(sessionId);

  const canModerateASession = () =>
    data?.me?.permissions.isGlobalModerator ||
    data?.me?.permissions.roles.audienceEngagement.length > 0;

  const canModerateVideo = sessionId =>
    data?.me?.permissions.roles.videoHost.includes(sessionId);

  const canModerateSpeaker = sessionId =>
    data?.me?.permissions.roles.speakerRoom.includes(sessionId);

  // user with no enhanced permission
  const isAttendee = sessionId =>
    !(
      canModerate(sessionId) ||
      canModerateSession(sessionId) ||
      canModerateVideo(sessionId) ||
      canModerateSpeaker(sessionId)
    );

  return {
    data,
    loading,
    error,
    // Session audience engagement permission based on old roles (to be deprecated in future)
    canModerate,
    // new engagement roles
    canModerateSession,
    canModerateVideo,
    canModerateSpeaker,
    isAttendee,
    canModerateASession
  };
};

export default useAuthorization;
